// extracted by mini-css-extract-plugin
export default {"block":"block--427750","label":"label--216f3c"};